<div class="vehicle-add">
  <app-vehicle-verification (cancelClick)="cancelCallback()" (continueClick)="continueCallback($event)"
    [currentVehicle]="currentVehicle"></app-vehicle-verification>
</div>